import axios from "axios";
import { getToken, removeToken } from "./token";
const baseURL = process.env.BASE_API; // 你的基础URL
import router from '@/router'; // 引入 Vue Router 实例
console.log("-===" + baseURL);

// 创建 axios 实例
const axiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 5000, // 请求超时时间
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    if (getToken()) {
      config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // 在这里添加请求前的处理逻辑，比如设置请求头
    config.headers["Content-Type"] = "application/json";
    config.headers["sign"] = "pojieqianming4sb";
    config.headers["type"] = "system";

    // 如果有token，添加到请求头中
    config.method = "post";
    // config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    console.log("拦截错误：重新登录2");

    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    // 你可以在这里根据实际情况修改条件
    if (response.status === 200) {
      if (response.data.status == 0) {
        return response.data;
      } else if (response.data.status == 403) {
        console.log("拦截错误：重新登录");
        router.push({ path: '/login' });  // 直接使用引入的 router 实例
        removeToken();
        return Promise.reject(response.data.message);
      } else if (response.data.status == 1) {
        alert(response.data.message);
        return Promise.reject(response.data.message);
      } else {

        return Promise.reject(response.data.message);
      }
    } else {
      // 抛出错误，这会让调用的地方进入 catch
      return Promise.reject(new Error("请求错误，状态码：" + response.status));
    }
  },
  (error) => {

    // 对响应错误做点什么
    // 如果响应是一个错误状态码，error.response 可以获取到响应对象
    if (error.response) {
      // 这里处理具体错误，比如根据状态码区分
      return Promise.reject(error);
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      return Promise.reject(new Error("无响应返回"));
    } else {
      // 在设置请求时发生了些什么事情触发了一个错误
      return Promise.reject(error);
    }
  }
);

/**
 * 封装request方法
 * @param {string} url 请求URL
 * @param {object} data 请求体中的数据
 * @param {string} method 请求方法，默认为'post'
 * @returns Promise
 */
const request = ({ url, data, method = "post" }) => {
  console.log(data);
  // data.sign = "pojieqianming4sb"
  return axiosInstance({
    url,
    method,
    data,
  });
};

export default request;
